<template>
	<!-- 模块管理 -->
	<div class="systemModule">
		<div class="systemModulePC pulbic_system_oparetionBlock">
			<div class="systemModulePC-side">
				<div class="systemModulePC-side-nav">
					<div class="systemModulePC-side-nav-item pulic_cursor" @click="typeClick(index)" :class="{systemCodeActive:codeIndex===index}"
					 v-for="(item,index) of moList" :key="index">
						<i class="el-icon-paperclip"></i>
						<span class="">{{item.PERTB001CA00}}</span>
					</div>

				</div>
			</div>
			<div class="systemModulePC-content">
				<div class="systemModulePC-content-btn public_operatBtn" style="margin-left: 0px;">
					<el-button type="primary" class="public_saleWater_xinzeng" icon="iconfont icon-tianjia1"  @click="newlyAdd">新增</el-button>
				</div>
				<!-- 默认 -->
				<div class="systemModulePC-content-table" v-if="codeIndex==-1">
					<div class="systemModulePC-content-table-li public-table-bg">
						<div class="systemModulePC-content-table-li-sorting">排序</div>
						<div class="systemModulePC-content-table-li-icon">小图标</div>
						<div class="systemModulePC-content-table-li-module">模块名称</div>
						<div class="systemModulePC-content-table-li-navtext">菜单类型</div>
						<div class="systemModulePC-content-table-li-src">资源路径</div>
						<div class="systemModulePC-content-table-li-pre">权限标识</div>
						<div class="systemModulePC-content-table-li-oper">操作</div>
					</div>
					<!--  -->
					<div class="systemModulePC-content-table-li public-hover public-table-bg" v-for="(item,index) of moList" :key="index">
						<div class="systemModulePC-content-table-li-sorting">{{item.PERTB001CA02}}</div>
						<div class="systemModulePC-content-table-li-icon"> </div>
						<div class="systemModulePC-content-table-li-module">{{item.PERTB001CA00}}</div>
						<div class="systemModulePC-content-table-li-navtext">{{item.PERTB001CB00=='ALL'?'全部':item.PERTB001CB00=='CUS-1'?'一级客户':item.PERTB001CB00=='CUS-2'?'二级客户':item.PERTB001CB00=='SYSTEM'?'超级管理员':'一、二级客户'}}</div>
						<div class="systemModulePC-content-table-li-src">{{item.PERTB001CA03}}</div>
						<div class="systemModulePC-content-table-li-pre">{{item.PERTB001CA05}}</div>
						<div class="systemModulePC-content-table-li-oper">
							<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary"  size="small" @click="modify(index)">修改</el-button>
							<el-button class="public_icon_jinyong public_icon_width" type="danger"  size="small" @click="deleteClick(index)">删除</el-button>
						</div>
					</div>
				</div>
				<!-- 点击模块名称 -->
				<div class="systemModulePC-content-table" v-else>
					<div class="systemModulePC-content-table-li public-table-bg">
						<div class="systemModulePC-content-table-li-sorting">排序</div>
						<div class="systemModulePC-content-table-li-icon">小图标</div>
						<div class="systemModulePC-content-table-li-module">模块名称</div>
						<div class="systemModulePC-content-table-li-navtext">菜单类型</div>
						<div class="systemModulePC-content-table-li-src">资源路径</div>
						<div class="systemModulePC-content-table-li-pre">权限标识</div>
						<div class="systemModulePC-content-table-li-oper" style="flex: 1.5;">操作</div>
					</div>
					<div class="systemModulePC-content-table-li public-hover public-table-bg" v-for="(item,index) of leftList" :key="index">
						<div class="systemModulePC-content-table-li-sorting">{{item.PERTB001CA02}}</div>
						<div class="systemModulePC-content-table-li-icon"> </div>
						<div class="systemModulePC-content-table-li-module">{{item.PERTB001CA00}}</div>
						<div class="systemModulePC-content-table-li-navtext">{{item.PERTB001CB00=='ALL'?'全部':item.PERTB001CB00=='CUS-1'?'一级客户':item.PERTB001CB00=='CUS-2'?'二级客户':item.PERTB001CB00=='SYSTEM'?'超级管理员':'一、二级客户'}}</div>
						<div class="systemModulePC-content-table-li-src">{{item.PERTB001CA03}}</div>
						<div class="systemModulePC-content-table-li-pre">{{item.PERTB001CA05}}</div>
						<div class="systemModulePC-content-table-li-oper" style="flex: 1.5;">
							<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary"  size="small" @click="modify(index)">修改</el-button>
							<el-button class="public_icon_anniu public_icon_width public_icon_margin" type="info"  size="small" @click="buttonManagement(index)" v-if="item.PERTB001CA01!=0">按钮管理</el-button>
							<el-button type="primary" class="public_icon_lieguanli public_icon_width public_icon_margin"  size="small" @click="columnManagement(index)" v-if="item.PERTB001CA01!=0">列管理</el-button>
							<el-button class="public_icon_jinyong public_icon_width" type="danger" size="small" @click="deleteClick(index)">删除</el-button>
						</div>
					</div>
				</div>
				<div style="text-align: center; height: 80px;line-height: 80px; border-bottom: 1px solid #CDCDCD;" v-if="this.moList.length==0">暂无数据</div>

				<!--  -->
				<div class="systemModulePC-pagesize">
					<el-pagination v-if="codeIndex==-1" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					 :current-page.sync="currentPage1"  :page-sizes="[10, 20, 30, 40]"
					 :page-size="limitMo" layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
					</el-pagination>
					<el-pagination v-else @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage1"
					  :page-sizes="[10, 20, 30, 40]" :page-size="limitLeft" layout="total,sizes, prev, pager, next, jumper"
					 :total="pagingPageLeft">
					</el-pagination>
				</div>
			</div>
			<!-- 新增 -->
			<div class="public-dialog">
				<el-dialog title="添加模块" :visible.sync="systemModulePCAddCode" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-add-code">
						<div class="systemModulePC-add-code-table">
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">父模块</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="valuePerAdd" @change="parentAdd" placeholder="请选择">
										<el-option v-for="item in typeAddList" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>

								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">菜单类型</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="valuePerTypeAdd" @change="menuTypeAdd" placeholder="请选择">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">模块名称</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="moduleName" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">链接地址</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="linkAddress" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">序号</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="number" v-model="orderNumber" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
						</div>
						<div class="systemModulePC-add-code-btn">
							<el-button type="primary" @click="preservationAdd">保存</el-button>
							<el-button type="warning" @click="cancelAdd">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 111 -->
			<!-- 修改 -->
			<div class="public-dialog">
				<el-dialog title="修改模块" :visible.sync="systemModulePCUpCode" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-add-code">
						<div class="systemModulePC-add-code-table">
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">父模块</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="parentModify" placeholder="顶级模块" v-if="codeIndex==-1" disabled>
										<el-option v-for="item in typeAddList" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
									<!--  -->
									<el-select v-model="parentModify" placeholder="请选择" disabled v-else>
										<el-option v-for="item in typeAddList" :key="item.value" :label="item.label" :value="item.value" >
										</el-option>
									</el-select>
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">菜单类型</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="menuTypeModify" placeholder="请选择">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">模块名称</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="modularModify" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">权限标识</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" readonly v-model="permissionModify" />
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">链接地址</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="addressModify" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">序号</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="number" v-model="noModify" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
						</div>
						<div class="systemModulePC-add-code-btn">
							<el-button type="primary" @click="preservationModular">保存</el-button>
							<el-button type="warning" @click="cancelModular">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 按钮管理 -->
			<div class="public-dialog">
				<el-dialog title="按钮管理" :visible.sync="systemModuleButton" width="60%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-content">
						<div class="systemModulePC-content-btn">
							<el-button type="primary" icon="iconfont icon-tianjia1" @click="buttonAdd">新增</el-button>
						</div>
						<!-- 默认 -->
						<div class="systemModulePC-content-table">
							<div class="systemModulePC-content-table-li public-table-bg">
								<div class="systemModulePC-content-table-li-module">模块名称</div>
								<div class="systemModulePC-content-table-li-navtext">按钮名称</div>
								<div class="systemModulePC-content-table-li-src">菜单类型</div>
								<div class="systemModulePC-content-table-li-pre">权限标识</div>
								<div class="systemModulePC-content-table-li-oper">操作</div>
							</div>
							<!--  -->
							<!--  -->
							<div style="text-align: center; margin-top: 30px;" v-if="buttonMsg=='暂无数据'">暂无数据</div>
							<div class="systemModulePC-content-table-li public-hover public-table-bg" v-else v-for="(item,index) of buttonList" :key="index">
								<div class="systemModulePC-content-table-li-module">{{item.parent}}</div>
								<div class="systemModulePC-content-table-li-navtext">{{item.PERTB001CA00}}</div>
								<div class="systemModulePC-content-table-li-src">{{item.PERTB001CB00=='ALL'?'全部':item.PERTB001CB00=='CUS-1'?'一级客户':item.PERTB001CB00=='CUS-2'?'二级客户':item.PERTB001CB00=='SYSTEM'?'超级管理员':'一、二级客户'}}</div>
								<div class="systemModulePC-content-table-li-pre">{{item.PERTB001CA05}}</div>
								<div class="systemModulePC-content-table-li-oper">
									<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary"  size="small" @click="buttonModify(index)">修改</el-button>
									<el-button class="public_icon_jinyong public_icon_width" type="danger"  size="small" @click="deleteClickButton(index)">删除</el-button>
								</div>
							</div>
						</div>
						<!--  -->
						<div class="systemModulePC-pagesize">
							<el-pagination @size-change="handleSizeChangeButton" @current-change="handleCurrentChangeButton"
							 :current-page.sync="currentPage2"  :page-sizes="[10, 20, 30, 40]"
							 :page-size="10" layout="total,sizes, prev, pager, next, jumper" :total="pagingPageButton">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>
			<!--  -->
			<!-- 新增 --按钮管理 -->
			<div class="public-dialog">
				<el-dialog title="新增按钮" :visible.sync="systemModuleButtonAdd" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-add-code">
						<div class="systemModulePC-add-code-table">
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">按钮名称</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="buttonName" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">菜单类型</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="menuTypeButton" @change="changAddButton" placeholder="请选择">
										<el-option v-for="item in buttonOptions" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">按钮地址</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="buttonAddress" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">序号</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="number" v-model="buttonNo" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
						</div>
						<div class="systemModulePC-add-code-btn">
							<el-button type="primary" @click="buttonPreAdd">保存</el-button>
							<el-button type="warning" @click="buttonCancelAdd">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 修改 --按钮管理 -->
			<div class="public-dialog">
				<el-dialog title="修改按钮" :visible.sync="systemModuleButtonModify" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-add-code">
						<div class="systemModulePC-add-code-table">
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">按钮名称</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="buttonName" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">菜单类型</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="menuTypeButton" placeholder="请选择">
										<el-option v-for="item in buttonOptions" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">权限标识</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="buttonPermission" readonly />
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">按钮地址</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="buttonAddress" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">序号</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="buttonNo" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
						</div>
						<div class="systemModulePC-add-code-btn">
							<el-button type="primary" @click="buttonProModify">保存</el-button>
							<el-button type="warning" @click="buttonCanModify">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!--  -->
			<!-- 列管理 -->
			<div class="public-dialog">
				<el-dialog title="列管理" :visible.sync="systemModuleColumn" width="60%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-content">
						<div class="systemModulePC-content-btn">
							<el-button type="primary" icon="iconfont icon-tianjia1" @click="newlyColumnAdd">新增</el-button>
						</div>
						<!-- 默认 -->
						<div class="systemModulePC-content-table">
							<div class="systemModulePC-content-table-li public-table-bg">
								<div class="systemModulePC-content-table-li-module">所属模块</div>
								<div class="systemModulePC-content-table-li-navtext">列名称</div>

								<div class="systemModulePC-content-table-li-pre">权限标识</div>
								<div class="systemModulePC-content-table-li-oper">操作</div>
							</div>
							<div style="text-align: center; margin-top: 30px;" v-if="ColumnMsg=='暂无数据'">暂无数据</div>
							<div class="systemModulePC-content-table-li public-hover public-table-bg" v-else v-for="(item,index) of ColumnList" :key="index">
								<div class="systemModulePC-content-table-li-module">{{item.parent}}</div>
								<div class="systemModulePC-content-table-li-navtext">{{item.PERTB001CA00}}</div>
								<div class="systemModulePC-content-table-li-pre">{{item.PERTB001CA05}}</div>
								<div class="systemModulePC-content-table-li-oper">
									<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary"  size="small" @click="ColumnModify(index)">修改</el-button>
									<el-button class="public_icon_jinyong public_icon_width" type="danger"  size="small" @click="deleteClickColumn(index)">删除</el-button>
								</div>
							</div>
						</div>
						<!--  -->
						<div class="systemModulePC-pagesize">
							<el-pagination @size-change="handleSizeChangeColumn" @current-change="handleCurrentChangeColumn"
							 :current-page.sync="currentPage3"  :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total,sizes, prev, pager, next, jumper" :total="pagingPageColumn">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>
			<!--  -->
			<!-- 新增 --列管理 -->
			<div class="public-dialog">
				<el-dialog title="新增列" :visible.sync="systemModuleColumnAdd" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-add-code">
						<div class="systemModulePC-add-code-table">
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">列名称</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="columnName" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">列字段</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="columnField" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">列类型</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="columnType" @change="changAddColumn" placeholder="请选择">
										<el-option v-for="item in columnOptions" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>


						</div>
						<div class="systemModulePC-add-code-btn">
							<el-button type="primary" @click="columnPreAdd">保存</el-button>
							<el-button type="warning" @click="columnCancelAdd">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 修改 --列管理 -->
			<div class="public-dialog">
				<el-dialog title="修改列" :visible.sync="systemModuleColumnModify" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-module-dialog">
					<div class="systemModulePC-add-code">
						<div class="systemModulePC-add-code-table">
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">列名称</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="columnName" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">列字段</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<input type="text" v-model="columnField" />
								</div>
								<div class="systemModulePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemModulePC-add-code-table-li">
								<div class="systemModulePC-add-code-table-li-name">列类型</div>
								<div class="systemModulePC-add-code-table-li-ipt">
									<el-select v-model="columnType" placeholder="请选择">
										<el-option v-for="item in columnOptions" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="systemModulePC-add-code-table-li-text"></div>
							</div>
						</div>
						<div class="systemModulePC-add-code-btn">
							<el-button type="primary" @click="ColumnProModify">保存</el-button>
							<el-button type="warning" @click="ColumnCanModify">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!--  -->
			<!-- 图标 -->
			<!-- <div class="public-dialog">
				<el-dialog title="修改图标" :visible.sync="systemModuleIcon" width="60%">
					<div class="systemModulePC-content">
						
						<div class="systemModulePC-content-table">
							<div class="systemModulePC-content-table-li">
								<div class="systemModulePC-content-table-li-module">所属模块</div>
								<div class="systemModulePC-content-table-li-navtext">列名称</div>
								
								<div class="systemModulePC-content-table-li-pre">权限标识</div>
								<div class="systemModulePC-content-table-li-oper">操作</div>
							</div>
						</div>
					</div>
				</el-dialog>
			</div> -->
			<!--  -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				options: [{
					value: '选项1',
					label: '全部',
					code: 'ALL'
				}, {
					value: '选项2',
					label: '超级管理员',
					code: 'SYSTEM'
				}, {
					value: '选项3',
					label: '一级客户',
					code: 'CUS-1'
				}, {
					value: '选项4',
					label: '二级客户',
					code: 'CUS-2'
				},{
					value: '选项5',
					label: '一、二级客户',
					code: 'CUS-1-2'
				},],
				typeList: ['销售系统', '生产系统', '进料系统', '门卫管理'],
				valuePerAdd: '',//父模块
				valuePerTypeAdd: '全部',//菜单类型
				PerAddTop:'选项1',//父模块--顶级模块
				pertb005List:this.$store.state.uobj.pertb005,//登陆缓存--用户信息
				moList: '', //默认列表
				codeIndex: -1, //类型切换
				systemModulePCAddCode: false, //新增--默认，模块名称
				systemModulePCUpCode: false, //修改--默认，模块名称
				systemModuleButton: false, //按钮管理
				systemModuleButtonAdd: false, //新增--按钮管理
				systemModuleButtonModify: false, //修改--按钮管理
				systemModuleColumn: false, //列管理
				systemModuleIcon: false, //图标
				// 默认
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				// 新增
				typeAddList: '', //父模块
				PERTB001CA01: '0', //父模块ID
				PERTB001CB00: 'ALL', //菜单类型ID
				moduleName: '', //模块名称
				linkAddress: '', //链接地址
				orderNumber: '', //序号
				codeNameAdd: 0, //校验模块名称的判断
				codeNumberAdd: 0, //校验序号的判断
				// 左侧列表
				leftList: '', //点击左侧列表显示相对应的列表

				pageLeft: 1, //点击左侧列表--中间数据列表页码
				limitLeft: 10, //每页的条数
				pagingPageLeft: 0, //分页--数据列表共有的条数
				currentPage1: 1,
				// 修改
				parentModify: '', //父模块
				PERTB001CA01Modify: '', //模块ID
				menuTypeModify: '', //菜单类型
				modularModify: '', //模块名称
				permissionModify: '', //权限标识
				addressModify: '', //链接地址
				noModify: '', //序号
				modifyIndex:-1,//修改--判断当前点击的列
				modifyIndexJudge:-1,//修改模块名称和序号的时候用来判断--是新增还是修改(新增和修改检验模块名称和序号唯一性用的是一个方法)

				// 按钮管理
				buttonList: '', //按钮数据列表
				buttonMsg: '', //列表是否有数据
				pageButton: 1, //按钮数据列表页码
				limitButton: 10, //每页的条数
				pagingPageButton: 0, //分页--数据列表共有的条数
				currentPage2: 1,
				buttonIndexJudge:0,//按钮管理--判断--是新增还是修改(新增和修改检验模块名称和序号唯一性用的是一个方法)
				codeNameButton: 0, //校验模块名称的判断
				codeNumberButton: 0, //校验序号的判断
				// 按钮新增
				buttonName: '', //按钮名称
				menuTypeButton: 'ALL', //菜单类型
				buttonAddress: '', //按钮地址
				buttonNo: '', //序号
				buttonIndex: 0, //判断当前点击的按钮是数据里面的第几条
				buttonListIndex:0,//修改按钮名称--判断当前点击的按钮的名称和修改的名字是否一样
				buttonOptions: [{
					value: '选项1',
					label: '全部',
					code: 'ALL'
				}, {
					value: '选项2',
					label: '超级管理员',
					code: 'SYSTEM'
				}, {
					value: '选项3',
					label: '一级客户',
					code: 'CUS-1'
				}, {
					value: '选项4',
					label: '二级客户',
					code: 'CUS-2'
				},{
					value: '选项5',
					label: '一、二级客户',
					code: 'CUS-1-2'
				},],
				buttonChangIndex: 0, //判断当前点击的buttonOptions是第几个
				// 修改
				buttonPermission: '', //权限标识
				ButtonPERTB001CA01: '', //按钮--修改--按钮id

				// 列管理
				systemModuleColumnAdd: false,
				systemModuleColumnModify: false,
				ColumnList: '', //按钮数据列表
				ColumnMsg: '', //列表是否有数据
				columnIndex: 0, //判断当前点击的按钮是数据里面的第几条
				columnChangIndex: 0, //判断当前点击的columnOptions是第几个
				columnOptions: [{
					value: '选项1',
					label: '第一列',
					code: '1'
				}, {
					value: '选项2',
					label: '第二列',
					code: '2'
				}, {
					value: '选项3',
					label: '第三列',
					code: '3'
				}, {
					value: '选项4',
					label: '第四列',
					code: '4'
				}, {
					value: '选项5',
					label: '第五列',
					code: '5'
				}, {
					value: '选项6',
					label: '第六列',
					code: '6'
				}, {
					value: '选项7',
					label: '第七列',
					code: '7'
				}, {
					value: '选项8',
					label: '第八列',
					code: '8'
				}, {
					value: '选项9',
					label: '第九列',
					code: '9'
				}, {
					value: '选项10',
					label: '第十列',
					code: '10'
				}],
				columnName: '', //列名称
				columnField: '', //列字段
				columnType: '', //列类型
				columnPERTB001ID: '', //列--修改--数据id
				columnIndexJudge:0,//列管理--判断--是新增还是修改(新增和修改检验模块名称和序号唯一性用的是一个方法)
				codeNameColumn: 0, //校验模块名称的判断
				ColumnListIndex:0,//修改列名称--判断当前点击的按钮的名称和修改的名字是否一样
				// 分页
				pageColumn: 1, //点击左侧列表--中间数据列表页码
				limitColumn: 10, //每页的条数
				pagingPageColumn: 0, //分页--数据列表共有的条数
				currentPage3: 1,
				// 历史缓存
				currentUrl:this.$route.path,
				historyInfo:''
			}
		},
		created(){
			// 赋值，缓存销毁
			this.historyInfo=JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if(this.historyInfo!=null&&this.historyInfo!=''){
				this.init()
			}
		},
		mounted() {
			this.pageList();
		},
		watch: {
			// 默认
			// 新增--模块名称
			moduleName: function(valName) {
				this.inspectionNameMo(valName)
			},
			// 新增--序号
			orderNumber: function(valNumber) {
				this.inspectionvalNumberMo(valNumber)
			},
			//修改--模块名称
			modularModify: function(valName) {
				this.inspectionNameMo(valName)	
			},
			// 修改--序号
			noModify: function(valNumber) {
				this.inspectionvalNumberMo(valNumber)	
			},
			// 按钮管理
			// 按钮名称--新增，修改
			buttonName: function(valName) {
				this.inspectionNameButton(valName,'')		
			},
			// 序号--新增，修改
			buttonNo: function(valNumber) {
				this.inspectionNameButton('',valNumber)	
			},
			// 列管理
			// 列名称--新增，修改
			columnName: function(valName) {
				this.inspectionNameColumn(valName)	
			},
		},
		// 存储数据
		beforeDestroy() {
			var obj={
				// codeIndex:this.codeIndex,//类型切换
				currentPage1:this.currentPage1,//当前页数
				pageMo:this.pageMo,//页码--默认
				limitMo:this.limitMo,//每页条数--默认
				pageLeft:this.pageLeft,//页码--左侧列表
				limitLeft:this.limitLeft//每页条数--左侧列表
			}
			sessionStorage.setItem(this.currentUrl,JSON.stringify(obj))
		},
		methods: {
			//初始化数据
			init(){
				// this.codeIndex=this.historyInfo.codeIndex
				this.currentPage1=this.historyInfo.currentPage1
				this.pageMo=this.historyInfo.pageMo
				this.limitMo=this.historyInfo.limitMo
				this.pageLeft=this.historyInfo.pageLeft
				this.limitLeft=this.historyInfo.limitLeft
				// console.log(this.codeIndex)
			},
			//默认-- 校验模块名称是否重复
			inspectionNameMo(valName) {
				var PERTB001CA00='';
				if (this.codeIndex == -1) {
					if (this.modifyIndexJudge == 0) {
						var PERTB001CA01 = '0';//修改--默认--父模块id
						PERTB001CA00 = this.moList[this.modifyIndex]['PERTB001CA00']//修改--默认--名称
					}else{
						if(this.PerAddTop=='选项1'){
							var PERTB001CA01 = '0';//新增--默认--父模块id
						}else{
							var PERTB001CA01 =this.PERTB001CA01
						}	
					}
				} else {
					if(this.modifyIndexJudge != -1 && this.modifyIndexJudge != 0){
						var PERTB001CA01 = this.moList[this.codeIndex]['PERTB001ID']//修改--左侧--父模块id
						PERTB001CA00 = this.leftList[this.modifyIndex]['PERTB001CA00']//修改--左侧--名称
					}else{
						var PERTB001CA01 =this.PERTB001CA01;
					}
				}
				var postData = {
					PERTB001CA01: PERTB001CA01, //父模块id
					PERTB001CA00: valName, //模块名称
				}
				var url = "/per/pertb001/doubleCheck";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						if (res.data.message == '模块名称不重复') {
							this.codeNameAdd = 0;
						}
					} else {
						this.codeNameAdd = 0;
						if(valName!=PERTB001CA00 && valName!=''){
							if (res.data.message == '模块名称重复') {
								this.codeNameAdd = 1;
							} 
							// this.$message({
							// 	message: '模块名称重复',
							// 	type: 'error'
							// });
						}else if(valName==PERTB001CA00){
							this.codeNameAdd = 0;
						}
					}
				})
			},
			//默认-- 校验序号是否重复
			inspectionvalNumberMo(valNumber) {
				var PERTB001CA02='';
				if (this.codeIndex == -1) {
					if (this.modifyIndexJudge == 0) {
						var PERTB001CA01 = '0';//修改--默认--父模块id
						PERTB001CA02 = this.moList[this.modifyIndex]['PERTB001CA02']//修改--默认--序号
					}else{
						if(this.PerAddTop=='选项1'){
							var PERTB001CA01 = '0';//新增--默认--父模块id
						}else{
							var PERTB001CA01 =this.PERTB001CA01
						}	
					}
				} else {
					if(this.modifyIndexJudge != -1 && this.modifyIndexJudge != 0){
						var PERTB001CA01 = this.moList[this.codeIndex]['PERTB001ID']//修改--左侧--父模块id
						PERTB001CA02 = this.leftList[this.modifyIndex]['PERTB001CA02']//修改--左侧--序号
					}else{
						var PERTB001CA01 =this.PERTB001CA01;
					}
				}
				var postData = {
					PERTB001CA01: PERTB001CA01, //父模块id
					PERTB001CA02: valNumber //序号
				}
				var url = "/per/pertb001/doubleCheck";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						if (res.data.message == '序号不重复') {
							this.codeNumberAdd = 0;
						}
					} else {
						if(valNumber!=PERTB001CA02 && valNumber!=''){
							if (res.data.message == '序号重复') {
							this.codeNumberAdd = 1;
						}
							// this.$message({
							// 	message: '序号重复',
							// 	type: 'error'
							// });
						}else if(valNumber==PERTB001CA02) {
							this.codeNumberAdd = 0;
						}
					}
				})
			},
			// 点击左侧列表显示相对应的列表
			leftLists(index) {
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(index)
				var PERTB001ID = this.moList[index]['PERTB001ID'];
				var postData = {
					PERTB001CA01: PERTB001ID, //模块id
					page: this.pageLeft,
					limit: this.limitLeft
				}
				var url = "/per/pertb001/selectPageListByPertb001ca01";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(()=>{
						loading.close()
					},300)
					if (res.data.code == 200) {
						this.leftList = res.data.data;
						this.pagingPageLeft = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
					}
				}).catch(errrse=>{
					loading.close()
				})
			},
			// 删除
			deleteClick(index) {
				// console.log(index)
				if (this.codeIndex == -1) {
					var pertb001ID = this.moList[index]['PERTB001ID'];
				} else {
					var pertb001ID = this.leftList[index]['PERTB001ID'];
				}
				var postData = {
					PERTB001ID: pertb001ID, //模块ID
					// PERTB001CA01: pertb001CA01,//父模块ID
				}
				var url = "/per/pertb001/delete.do";
				this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							if (this.codeIndex == -1) {
								this.pageList();
							} else { //当删除左侧列表所添加的顶级模块时
								if (this.leftList[index]['PERTB001CA01'] == 0) {
									// 判断当前用户有没有顶级模块
									if (this.moList.length == 1) { //当只剩下一个顶级模块的时候
										this.pageList();
										this.leftList = '';
									} else { //剩下一个以上顶级模块的时候
										this.pageList();
										this.codeIndex = 0
										this.leftLists(this.codeIndex);
									}
								} else { //当删除顶级模块里面添加的模块时
									if (this.leftList.length == 1) {
										this.codeIndex = 0
										if (this.moList.length == 1) { //当该顶级模块下只剩一个模块的时候
											this.pageList();
											this.leftList = '';
										} else { //当该顶级模块下剩下一个以上模块的时候
											this.pageList();
											this.leftLists(this.codeIndex);
										}

									} else {
										this.leftLists(this.codeIndex);
									}
								}

							}
							this.$message({
								type: 'success',
								message: '删除成功',
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.message,
							});
						}

					})
				})
			},
			// 新增--保存
			preservationAdd() {
				if (this.codeNameAdd != 1 && this.codeNumberAdd != 1) {
					if (this.moduleName == '') { //模块名称
						this.$message({
							message: '模块名称不能为空',
							type: 'error'
						});
					} else if (this.linkAddress == '') { //链接地址
						this.$message({
							message: '链接地址不能为空',
							type: 'error'
						});
					} else if (this.orderNumber == '') { //序号
						this.$message({
							message: '序号不能为空',
							type: 'error'
						});
					} else {
						if (this.codeIndex == -1) {
							var postData = {
								PERTB001CA01: this.PERTB001CA01, //父模块ID
								PERTB001CB00: this.PERTB001CB00, //菜单类型
								PERTB001CA00: this.moduleName, //模块名称
								PERTB001CA03: this.linkAddress, //链接地址
								PERTB001CA02: this.orderNumber //序号
							}
						} else {
							var PERTB001CA01 = this.moList[this.codeIndex]['PERTB001ID'];
							// console.log(PERTB001CA01)
							var postData = {
								PERTB001CA01: PERTB001CA01, //父模块ID
								PERTB001CB00: this.PERTB001CB00, //菜单类型
								PERTB001CA00: this.moduleName, //模块名称
								PERTB001CA03: this.linkAddress, //链接地址
								PERTB001CA02: this.orderNumber //序号
							}
						}
						let loading = this.$loading({
							lock: true,
							text: '请求中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.5)'
						});
						var url = "/per/pertb001/insertPertb001";
						this.axios.post(url, postData).then(res => {
							// console.log(res)
							if (res.data.code == 200) {
								if (this.codeIndex == -1) {
									this.pageList();
								} else {
									this.leftLists(this.codeIndex)
								}
								this.systemModulePCAddCode = false
								this.$message({
									message: '新增成功',
									type: 'success'
								});
							} else {
								this.$message({
									message: res.data.message,
									type: 'error'
								});
							}
							setTimeout(()=>{
								loading.close()
							},300)
						}).catch(()=>{
							loading.close()
						})
					}
				} else if (this.codeNameAdd == 1) {
					this.$message({
						message: '模块名称重复',
						type: 'error'
					});
				} else if (this.codeNumberAdd == 1) {
					this.$message({
						message: '序号重复',
						type: 'error'
					});
				}
			},
			// 新增点击菜单类型下拉列表
			menuTypeAdd(e) {
				// console.log(e.slice(2))
				// console.log(e.slice(2) - 1)
				this.PERTB001CB00 = this.options[e.slice(2) - 1]['code'];
				// console.log(this.PERTB001CB00)
			},
			// 新增点击父模块下拉列表
			parentAdd(e) {
				this.PerAddTop=e;
				this.PERTB001CA01 = this.typeAddList[e.slice(2) - 1]['code'];
				// console.log(this.PERTB001CA01)
			},
			// 新增--取消
			cancelAdd() {
				this.systemModulePCAddCode = false;
			},
			// 新增
			newlyAdd() {
				this.systemModulePCAddCode = true;
				this.valuePerTypeAdd = this.options[0]['value'];
				this.moduleName = ''; //模块名称
				this.linkAddress = ''; //链接地址
				this.orderNumber = ''; //序号
				this.parentType();
			},
			//父模块下拉列表处理
			parentType() {
				var List = [{
					value: '选项1',
					label: '顶级模块',
					code: '0'
				}];
				var newarr = [];
				var arr = [...List, ...this.moList];
				for (var i = 0; i < arr.length; i++) {
					if (i == 0) {
						newarr.push(arr[0])
					} else {
						newarr.push({
							'value': '选项' + (i + 1),
							"label": arr[i]['PERTB001CA00'],
							'code': arr[i]['PERTB001ID']
							// "label": arr[i]['PERTB001CA01'],
						})
					}
				}
				this.typeAddList = newarr;
				if (this.codeIndex == -1) {
					this.valuePerAdd= this.typeAddList[0]['value'];
				} else {
					this.valuePerAdd= this.typeAddList[this.codeIndex + 1]['value'];
					this.PERTB001CA01=this.typeAddList[this.codeIndex + 1]['code'];
				}
			},
			// 修改--取消
			cancelModular() {
				this.systemModulePCUpCode = false;
			},
			// 修改--保存
			preservationModular() {
				if (this.codeNameAdd != 1 && this.codeNumberAdd != 1) {
					if (this.modularModify == '') { //模块名称
						this.$message({
							message: '模块名称不能为空',
							type: 'success'
						});
					} else if (this.addressModify == '') { //链接地址
						this.$message({
							message: '链接地址不能为空',
							type: 'success'
						});
					} else if (this.noModify == '' && this.noModify != 0) { //序号
						this.$message({
							message: '序号不能为空',
							type: 'success'
						});
					} else {
						this.preservationModularPost();
					}
					// 
				} else if (this.codeNameAdd == 1) {
					this.$message({
						message: '模块名称重复',
						type: 'error'
					});
				} else if (this.codeNumberAdd == 1) {
					this.$message({
						message: '序号重复',
						type: 'error'
					});
				}

			},
			preservationModularPost() {
				var menuTypeModify;
				// console.log(this.parentModify)
				if (this.menuTypeModify == '选项1') {
					menuTypeModify = 'ALL';
				} else if (this.menuTypeModify == '选项2') {
					menuTypeModify = 'SYSTEM';;
				} else if (this.menuTypeModify == '选项3') {
					menuTypeModify = 'CUS-1';
				} else if (this.menuTypeModify == '选项4') {
					menuTypeModify = 'CUS-2';
				}else if (this.menuTypeModify == '选项5') {
					menuTypeModify = 'CUS-1-2';
				}
				// console.log(menuTypeModify)
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					PERTB001ID: this.PERTB001CA01Modify, //模块id
					PERTB001CB00: menuTypeModify, //菜单类型
					PERTB001CA00: this.modularModify, //模块名称
					// PERTB001CA05: this.permissionModify,//权限标识
					PERTB001CA03: this.addressModify, //链接地址
					PERTB001CA02: this.noModify //序号
				}
				var url = "/per/pertb001/updatePertb001";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						if (this.codeIndex == -1) {
							this.pageList();
						} else {
							this.leftLists(this.codeIndex)
						}
						this.systemModulePCUpCode = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 修改
			modify(index) {
				this.systemModulePCUpCode = true;
				this.modifyIndex=index//当前修改列的下标
				this.modifyIndexJudge=0;
				if (this.codeIndex == -1) {
					this.menuTypeModify = this.moList[index]['PERTB001CB00'];
					this.modifyIndexJudge=0;//修改模块名称和序号的时候用来判断--是新增还是修改(新增和修改检验模块名称和序号唯一性用的是一个方法)
					// console.log(this.modifyIndexJudge)
				} else {
					this.menuTypeModify = this.leftList[index]['PERTB001CB00'];
					this.modifyIndexJudge++;
					// console.log(this.modifyIndexJudge)
				}
				var typeIndex = 0;
				// console.log(this.menuTypeModify)
				if (this.menuTypeModify == 'ALL') {
					this.menuTypeModify = '全部';
					typeIndex = 0;
				} else if (this.menuTypeModify == 'SYSTEM') {
					this.menuTypeModify = '超级管理员';
					typeIndex = 1;
				} else if (this.menuTypeModify == 'CUS-1') {
					this.menuTypeModify = '一级客户';
					typeIndex = 2;
				} else if (this.menuTypeModify == 'CUS-2') {
					this.menuTypeModify = '二级客户';
					typeIndex = 3;
				} else if (this.menuTypeModify == 'CUS-1-2') {
					this.menuTypeModify = '一、二级客户';
					typeIndex = 4;
				}
				// console.log(this.codeIndex)
				if (this.codeIndex == -1) {
					this.PERTB001CA01Modify = this.moList[index]['PERTB001ID'];
					this.modularModify = this.moList[index]['PERTB001CA00']; //模块名称
					this.noModify = this.moList[index]['PERTB001CA02']; //序号
					this.permissionModify = this.moList[index]['PERTB001CA05']; //权限标识
					this.addressModify = this.moList[index]['PERTB001CA03']; //按钮地址
				} else {
					this.PERTB001CA01Modify = this.leftList[index]['PERTB001ID'];
					this.parentModify = this.typeAddList[this.codeIndex + 1]['value'];
					this.modularModify = this.leftList[index]['PERTB001CA00']; //模块名称
					this.noModify = this.leftList[index]['PERTB001CA02']; //序号
					this.permissionModify = this.leftList[index]['PERTB001CA05']; //权限标识
					this.addressModify = this.leftList[index]['PERTB001CA03']; //按钮地址
				}
				this.menuTypeModify = this.options[typeIndex]['value']; //菜单类型
				// console.log(this.noModify)
				// this.inspectionNameMo('',this.noModify)
			},
			// 列表
			pageList() {
				var postData = {
					PERTB001CA01: '0', //父模块id--默认
					page: this.pageMo,
					limit: this.limitMo
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/per/pertb001/selectPageListByPertb001ca01";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.moList = res.data.data || ''
						this.pagingPageMo = res.data.count || 0
					} else {
						this.moList = []
						this.pagingPageMo = 0
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(errrse=>{
					loading.close()
				})
			},
			// 类型切换
			typeClick(index) {
				this.codeIndex = index;
				// this.value = this.typeList[index]['label'];
				this.parentType();
				this.leftLists(index);
				// this.optionOne='选项'+(this.codeIndex+2);
			},
			// 上一页
			// prevPage() {
			// 	if (this.codeIndex == -1) {
			// 		this.pageMo--;
			// 		this.pageList();
			// 	} else {
			// 		this.pageLeft--;
			// 		this.leftLists(this.codeIndex);
			// 	}
			// },
			// // 下一页
			// nextPage() {
			// 	if (this.codeIndex == -1) {
			// 		this.pageMo++;
			// 		this.pageList();
			// 	} else {
			// 		this.pageLeft++;
			// 		this.leftLists(this.codeIndex);
			// 	}
			// },
			// 每页显示条数
			handleSizeChange(val) {
				if (this.codeIndex == -1) {
					this.limitMo = val;
					this.pageList();
				} else {
					this.limitLeft = val;
					this.leftLists(this.codeIndex);
				}
				// console.log(`每页 ${val} 条`);
			},
			// 点击页码
			handleCurrentChange(val) {
				if (this.codeIndex == -1) {
					this.pageMo = val;
					this.pageList();
				} else {
					this.pageLeft = val;
					this.leftLists(this.codeIndex);
				}
				// console.log(`当前页: ${val}`);
			},
			// 按钮管理
			// 删除
			deleteClickButton(index) {
				// console.log(this.buttonList)
				var PERTB001ID = this.buttonList[index]['PERTB001ID'];
				// console.log(PERTB001ID)
				var postData = {
					PERTB001ID: PERTB001ID, //模块ID
				}
				var url = "/per/pertb001/delete.do";
				this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.buttonLists(this.buttonIndex);
							this.$message({
								type: 'success',
								message: '删除成功',
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.message,
							});
						}

					})
				})
			},
			
			// 校验模块名称或序号是否重复
			inspectionNameButton(valName, valNumber) {
				if (this.buttonIndexJudge == 0) {
						var PERTB001CA01 = this.leftList[this.buttonIndex]['PERTB001ID'];//新增
					}else{
						var PERTB001CA01 = this.ButtonPERTB001CA01;//修改
					}
				var postData = {
					PERTB001CA01: PERTB001CA01, //父模块id
					PERTB001CA00: valName, //模块名称
					PERTB001CA02: valNumber //序号
				}
				var url = "/per/pertb001/doubleCheck";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						if (res.data.message == '模块名称不重复') {
							this.codeNameButton = 0;
							// this.$message({
							// 	message: '按钮名称不重复',
							// 	type: 'success'
							// });
						} else if (res.data.message == '序号不重复') {
							this.codeNumberButton = 0;
							// this.$message({
							// 	message: '序号不重复',
							// 	type: 'success'
							// });
						}
					} else {
						this.codeNameButton = 0;
						var PERTB001CA00=this.buttonList[this.buttonListIndex]['PERTB001CA00']
						if(this.buttonIndexJudge == 0){
								if (res.data.message == '模块名称重复') {
								this.codeNameButton = 1;
								this.$message({
									message: '按钮名称重复',
									type: 'error'
								});
							}else if (res.data.message == '序号重复') {
								this.codeNumberButton = 1;
								this.$message({
									message: '序号重复',
									type: 'error'
								});
							}
						}else{
							if(valName!=PERTB001CA00){
								if (res.data.message == '模块名称重复') {
								this.codeNameButton = 1;
								this.$message({
									message: '按钮名称重复',
									type: 'error'
								});
							}
							}else if(valName==PERTB001CA00){
								this.codeNameButton = 0;
							}else if (res.data.message == '序号重复') {
								this.codeNumberButton = 1;
								this.$message({
									message: '序号重复',
									type: 'error'
								});
							}
						}
						
					}
				})
			},
			// 新增--保存
			buttonPreAdd() {
				if (this.codeNameButton != 1 && this.codeNumberButton != 1) {
					if (this.buttonName == '') { //模块名称
					this.$message({
						message: '按钮名称不能为空',
						type: 'success'
					});
				} else if (this.buttonAddress == '') { //链接地址
					this.$message({
						message: '按钮地址不能为空',
						type: 'success'
					});
				} else if (this.buttonNo == '') { //序号
					this.$message({
						message: '序号不能为空',
						type: 'success'
					});
				} else {
					this.buttonPreAddPost();
				}
				}else if (this.codeNameButton == 1) {
					this.$message({
						message: '按钮名称重复',
						type: 'error'
					});
				} else if (this.codeNumberButton == 1) {
					this.$message({
						message: '序号重复',
						type: 'error'
					});
				}
				
			},
			// 按钮添加请求
			buttonPreAddPost() {
				var PERTB001CA01 = this.leftList[this.buttonIndex]['PERTB001ID'];
				var menuTypeButton = this.buttonOptions[this.buttonChangIndex]['code'];
				var postData = {
					PERTB001CA01: PERTB001CA01, //父模块id
					PERTB001CA00: this.buttonName, //按钮名称
					PERTB001CB00: menuTypeButton, //菜单类型
					PERTB001CA02: this.buttonNo, //序号
					PERTB001CA03: this.buttonAddress, //按钮地址
					// PERTB005CA00: '666666' ,//当前登录用户名
					PERTB005CA00:this.pertb005List['pertb005ca02']//当前登录用户名
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/per/pertb001/insertPertb001ForButton";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.buttonLists(this.buttonIndex);
						this.systemModuleButtonAdd = false;
						this.$message({
							message: res.data.message,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 新增点击菜单类型列表
			changAddButton(e) {
				this.menuTypeButton = this.buttonOptions[e.slice(2) - 1]['value'];
				this.buttonChangIndex = e.slice(2) - 1;
				// console.log(this.buttonChangIndex)
				// console.log(this.menuTypeButton)
			},
			// 新增--取消
			buttonCancelAdd() {
				this.systemModuleButtonAdd = false;
			},
			// 新增
			buttonAdd() {
				this.systemModuleButtonAdd = true;
				this.buttonIndexJudge=0;
				console.log(this.buttonIndex)
				this.buttonName = ''; //按钮名称
				this.buttonNo = ''; //序号
				this.buttonAddress = ''; //按钮地址
				// this.menuTypeButton = this.buttonOptions[this.buttonIndex]['value'];
			},
			// 修改--保存
			buttonProModify() {
				if (this.codeNameButton != 1 && this.codeNumberButton != 1) {
					if (this.buttonName == '') { //模块名称
					this.$message({
						message: '按钮名称不能为空',
						type: 'error'
					});
				} else if (this.buttonAddress == '') { //链接地址
					this.$message({
						message: '按钮地址不能为空',
						type: 'error'
					});
				} else if (this.buttonNo == '') { //序号
					this.$message({
						message: '序号不能为空',
						type: 'error'
					});
				} else {
					this.buttonPreModPost();
				}
				}else if (this.codeNameButton == 1) {
					this.$message({
						message: '按钮名称重复',
						type: 'error'
					});
				} else if (this.codeNumberButton == 1) {
					this.$message({
						message: '序号重复',
						type: 'error'
					});
				}
				
			},
			// 按钮修改保存请求
			buttonPreModPost() {
				var menuTypeButton;
				// console.log(this.menuTypeButton)
				if (this.menuTypeButton == '选项1') {
					menuTypeButton = 'ALL';
				} else if (this.menuTypeButton == '选项2') {
					menuTypeButton = 'SYSTEM';
				} else if (this.menuTypeButton == '选项3') {
					menuTypeButton = 'CUS-1';
				} else if (this.menuTypeButton == '选项4') {
					menuTypeButton = 'CUS-2';
				}else if(this.menuTypeButton == '选项5'){
					menuTypeButton ='CUS-1-2';
				}
				// console.log(menuTypeButton)
				var postData = {
					PERTB001ID: this.ButtonPERTB001CA01, //按钮id
					PERTB001CA00: this.buttonName, //按钮名称
					PERTB001CB00: menuTypeButton, //菜单类型
					PERTB001CA02: this.buttonNo, //序号
					PERTB001CA03: this.buttonAddress, //按钮地址
					// PERTB005CA00: '666666' ,//当前登录用户名
					PERTB005CA00:this.pertb005List['pertb005ca02']//当前登录用户名
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/per/pertb001/updatePertb001ForButton";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.buttonLists(this.buttonIndex);
						this.systemModuleButtonModify = false;
						this.$message({
							message: res.data.message,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(errrse=>{
					loading.close()
				})
			},
			// 修改--取消
			buttonCanModify() {
				this.systemModuleButtonModify = false
			},
			// 修改
			buttonModify(index) {
				this.systemModuleButtonModify = true;
				this.buttonIndexJudge++;
				this.buttonListIndex=index;
				this.menuTypeButton = this.buttonList[index]['PERTB001CB00'];
				this.ButtonPERTB001CA01 = this.buttonList[index]['PERTB001ID']; //按钮--修改--按钮id
				// console.log(index)
				var typeIndex = 0;
				if (this.menuTypeButton == 'ALL') {
					this.menuTypeButton = '全部';
					typeIndex = 0;
				} else if (this.menuTypeButton == 'SYSTEM') {
					this.menuTypeButton = '超级管理员';
					typeIndex = 1;
				} else if (this.menuTypeButton == 'CUS-1') {
					this.menuTypeButton = '一级客户';
					typeIndex = 2;
				} else if (this.menuTypeButton == 'CUS-2') {
					this.menuTypeButton = '二级客户';
					typeIndex = 3;
				}else if (this.menuTypeButton == 'CUS-1-2') {
					this.menuTypeButton = '一、二级客户';
					typeIndex = 4;
				}
				this.menuTypeButton = this.buttonOptions[typeIndex]['value'];
				this.buttonName = this.buttonList[index]['PERTB001CA00']; //按钮名称
				this.buttonPermission = this.buttonList[index]['PERTB001CA05']; //权限标识
				this.buttonAddress = this.buttonList[index]['PERTB001CA03']; //按钮地址
				this.buttonNo = this.buttonList[index]['PERTB001CA02']; //序号
			},
			// 按钮管理点击显示
			buttonManagement(index) {
				this.systemModuleButton = true;
				this.buttonIndex = index;
				var type=this.leftList[index].PERTB001CB00
				this.menuTypeButton=type=='ALL'?'全部':type=='CUS-1'?'一级客户':type=='CUS-2'?'二级客户':type=='SYSTEM'?'超级管理员':'一、二级客户'
				this.buttonLists(index);
			},

			// 列表
			buttonLists(index) {
				this.buttonList=[]
				var PERTB001ID = this.leftList[index]['PERTB001ID'];
				var postData = {
					PERTB001ID: PERTB001ID, //模块id
					page: this.pageButton,
					limit: this.limitButton
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/per/pertb001/selectListPertb001ForButton";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.buttonList = res.data.data;
						this.pagingPageButton = res.data.count;
						this.buttonMsg = res.data.message;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(errrse=>{
					loading.close()
				})
			},
			// 上一页
			// prevPageButton() {
			// 	this.pageButton--;
			// 	this.buttonLists(this.buttonIndex)
			// },
			// // 下一页
			// nextPageButton() {
			// 	this.pageButton++;
			// 	this.buttonLists(this.buttonIndex)
			// },
			// 每页显示条数
			handleSizeChangeButton(val) {
				this.limitButton = val;
				this.buttonLists(this.buttonIndex)
				// console.log(`每页 ${val} 条`);
			},
			// 点击页码
			handleCurrentChangeButton(val) {
				this.pageButton = val;
				this.buttonLists(this.buttonIndex)
				// console.log(`当前页: ${val}`);
			},


			// 列管理
			// 删除
			deleteClickColumn(index) {
				var PERTB001ID = this.ColumnList[index]['PERTB001ID'];
				var postData = {
					PERTB001ID: PERTB001ID, //模块ID
				}
				var url = "/per/pertb001/delete.do";
				this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.columnLists(this.columnIndex);
							this.$message({
								type: 'success',
								message: res.data.message,
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.message,
							});
						}

					})
				})
			},
			// 校验模块名称或序号是否重复
			inspectionNameColumn(valName) {
				if (this.columnIndexJudge == 0) {
						var PERTB001CA01 = this.leftList[this.columnIndex]['PERTB001ID'];//新增
					}else{
						// var PERTB001CA01 = this.buttonList[this.buttonIndex]['PERTB001ID'];//修改
						var PERTB001CA01 = this.columnPERTB001ID;//修改
					}
				var postData = {
					PERTB001CA01: PERTB001CA01, //父模块id
					PERTB001CA00: valName, //模块名称
					PERTB001CA02: '' //序号
				}
				var url = "/per/pertb001/doubleCheck";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						if (res.data.message == '模块名称不重复') {
							this.codeNameColumn = 0;
							// this.$message({
							// 	message: '列名称不重复',
							// 	type: 'success'
							// });
						}
					} else {
						this.codeNameColumn = 0;
						if(valName!=this.ColumnList[this.ColumnListIndex]['PERTB001CA00']){
							if (res.data.message == '模块名称重复') {
							this.codeNameColumn = 1;
							this.$message({
								message: '列名称重复',
								type: 'error'
							});
						}
						}else{
							// this.$message({
							// 	message: '列名称不重复',
							// 	type: 'success'
							// });
						}
						
					}
				})
			},
			// 新增--保存
			columnPreAdd() {
				if(this.codeNameColumn!=1){
					if (this.columnName == '') { //模块名称
					this.$message({
						message: '列名称不能为空',
						type: 'error'
					});
				} else if (this.columnField == '') { //链接地址
					this.$message({
						message: '列字段不能为空',
						type: 'error'
					});
				} else {
					this.columnPreAddPost();
				}
				}else if(this.codeNameColumn==1){
					this.$message({
						message: '列名称重复',
						type: 'error'
					});
				}
				
			},
			// 列添加请求
			columnPreAddPost() {
				var PERTB001CA01 = this.leftList[this.columnIndex]['PERTB001ID'];
				var columnType;
				if (this.columnType == '选项1') {
					columnType = '1';
				} else if (this.columnType == '选项2') {
					columnType = '2';;
				} else if (this.columnType == '选项3') {
					columnType = '3';
				} else if (this.columnType == '选项4') {
					columnType = '4';
				} else if (this.columnType == '选项5') {
					columnType = '5';
				} else if (this.columnType == '选项6') {
					columnType = '6';
				} else if (this.columnType == '选项7') {
					columnType = '7';
				} else if (this.columnType == '选项8') {
					columnType = '8';
				} else if (this.columnType == '选项9') {
					columnType = '9';
				} else if (this.columnType == '选项10') {
					columnType = '10';
				}
				var postData = {
					PERTB001CA01: PERTB001CA01, //父模块id
					PERTB001CA00: this.columnName, //列名称
					PERTB001CA05: this.columnField, //列字段
					PERTB001CA02: columnType, //列序号
					// PERTB005CA00: '666666' //当前登录用户名
					PERTB005CA00:this.pertb005List['pertb005ca02']//当前登录用户名
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/per/pertb001/insertPertb001ForRow";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.columnLists(this.columnIndex);
						this.systemModuleColumnAdd = false;
						this.$message({
							message: res.data.message,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 新增点击列类型列表
			changAddColumn(e) {
				this.columnType = this.columnOptions[e.slice(2) - 1]['value'];
				this.columnChangIndex = e.slice(2) - 1;
				// console.log(this.columnChangIndex)
			},
			// 新增--取消
			columnCancelAdd() {
				this.systemModuleColumnAdd = false;
			},
			// 新增
			newlyColumnAdd() {
				this.systemModuleColumnAdd = true;
				this.columnIndexJudge = 0;
				// console.log(this.columnIndex)
				this.columnType = this.columnOptions[this.columnIndex]['value']; //列类型
				this.columnName = ''; //列名称
				this.columnField = ''; //列字段
			},
			// 修改--保存
			ColumnProModify() {
					if(this.codeNameColumn!=1){
						if (this.columnName == '') { //模块名称
					this.$message({
						message: '列名称不能为空',
						type: 'error'
					});
				} else if (this.columnField == '') { //链接地址
					this.$message({
						message: '列字段不能为空',
						type: 'error'
					});
				} else {
					this.ColumnPreModPost();
				}
					}else if(this.codeNameColumn==1){
					this.$message({
						message: '列名称重复',
						type: 'error'
					});
				}
				
			},
			// 列修改保存请求
			ColumnPreModPost() {
				var columnType;
				if (this.columnType == '选项1') {
					columnType = '1';
				} else if (this.columnType == '选项2') {
					columnType = '2';;
				} else if (this.columnType == '选项3') {
					columnType = '3';
				} else if (this.columnType == '选项4') {
					columnType = '4';
				} else if (this.columnType == '选项5') {
					columnType = '5';
				} else if (this.columnType == '选项6') {
					columnType = '6';
				} else if (this.columnType == '选项7') {
					columnType = '7';
				} else if (this.columnType == '选项8') {
					columnType = '8';
				} else if (this.columnType == '选项9') {
					columnType = '9';
				} else if (this.columnType == '选项10') {
					columnType = '10';
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					PERTB001ID: this.columnPERTB001ID, //数据id
					PERTB001CA00: this.columnName, //列名称
					PERTB001CA05: this.columnField, //列字段
					PERTB001CA02: columnType, //列序号
					// PERTB005CA00: '666666' //当前登录用户名
					PERTB005CA00:this.pertb005List['pertb005ca02']//当前登录用户名
				}
				var url = "/per/pertb001/updatePertb001ForRow";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.columnLists(this.columnIndex);
						this.systemModuleColumnModify = false;
						this.$message({
							message: res.data.message,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 修改--取消
			ColumnCanModify() {
				this.systemModuleColumnModify = false
			},
			// 修改
			ColumnModify(index) {
				this.systemModuleColumnModify = true;
				this.columnIndexJudge++;
				this.ColumnListIndex=index;
				this.columnType = this.ColumnList[index]['PERTB001CA02'];
				this.columnPERTB001ID = this.ColumnList[index]['PERTB001ID']; //列管理--修改--按钮id
				var typeIndex = 0;
				if (this.columnType == '1') {
					this.columnType = '第一列';
					typeIndex = 0;
				} else if (this.columnType == '2') {
					this.columnType = '第二列';
					typeIndex = 1;
				} else if (this.columnType == '3') {
					this.columnType = '第三列';
					typeIndex = 2;
				} else if (this.columnType == '4') {
					this.columnType = '第四列';
					typeIndex = 3;
				} else if (this.columnType == '5') {
					this.columnType = '第五列';
					typeIndex = 4;
				} else if (this.columnType == '6') {
					this.columnType = '第六列';
					typeIndex = 5;
				} else if (this.columnType == '7') {
					this.columnType = '第七列';
					typeIndex = 6;
				} else if (this.columnType == '8') {
					this.columnType = '第八列';
					typeIndex = 7;
				} else if (this.columnType == '9') {
					this.columnType = '第九列';
					typeIndex = 8;
				} else if (this.columnType == '10') {
					this.columnType = '第十列';
					typeIndex = 9;
				}
				this.columnType = this.columnOptions[typeIndex]['value'];
				this.columnName = this.ColumnList[index]['PERTB001CA00']; //列名称
				this.columnField = this.ColumnList[index]['rowField'];; //列字段
			},
			// 列管理点击显示
			columnManagement(index) {
				this.systemModuleColumn = true;
				this.columnIndex = index;
				this.columnLists(index);
			},

			// 列表
			columnLists(index) {
				var PERTB001ID = this.leftList[index]['PERTB001ID'];
				var postData = {
					PERTB001ID: PERTB001ID, //模块id
					page: this.pageColumn,
					limit: this.limitColumn
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/per/pertb001/selectListPertb001ForRow";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.ColumnList = res.data.data;
						this.pagingPageColumn = res.data.count;
						this.ColumnMsg = res.data.message;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(errrse=>{
					loading.close()
				})
			},
			// 上一页
			// prevPageColumn() {
			// 	this.pageColumn--;
			// 	this.columnLists(this.columnIndex)
			// },
			// // 下一页
			// nextPageColumn() {
			// 	this.pageColumn++;
			// 	this.columnLists(this.columnIndex)
			// },
			// 每页显示条数
			handleSizeChangeColumn(val) {
				this.limitColumn = val;
				this.columnLists(this.columnIndex)
				// console.log(`每页 ${val} 条`);
			},
			// 点击页码
			handleCurrentChangeColumn(val) {
				this.pageColumn = val;
				this.columnLists(this.columnIndex)
				// console.log(`当前页: ${val}`);
			},
		}
	}
</script>

<style scoped>
	.systemModulePC {
		display: flex;
		font-size: 16px;
		color: #333;
		padding: 30px 40px 20px 20px;
	}

	.systemModulePC-side {
		flex: .2;
	}

	.systemModulePC-side-nav-item {
		height: 40px;
		line-height: 40px;
		/* text-align: center; */
		padding-left: 20px;
	}

	.systemCodeActive {
		background-color: #1AA0FF !important;
		color: #FFF;
	}

	.systemModulePC-side-nav-item i {
		margin-right: 5px;
	}
	.systemModulePC-side-nav-item:hover {
		background-color: #ccc;
	}
	.systemModulePC-side-nav-item:focus {
		background-color: #ccc;
	}

	.systemModulePC-content {
		flex: 2;
		padding-left: 20px;
	}
.systemModulePC-content-table{
	margin-top: 20px;
}
	.systemModulePC-content-table-li {
		display: flex;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #CDCDCD;
	}
	.systemModulePC-content-table-li:first-child{
		font-weight: bold;
		height: 48px;
		line-height: 48px;
		font-size: 16px;
		
	}
	.systemModulePC-content-table-li>div {
		text-align: center;
	}

	.systemModulePC-content-table-li-sorting {
		flex: .2;
	}

	.systemModulePC-content-table-li-icon {
		flex: .2;
	}

	.systemModulePC-content-table-li-module {
		flex: .4;
	}

	.systemModulePC-content-table-li-navtext {
		flex: .4;
	}

	.systemModulePC-content-table-li-src {
		flex: .5;
		width: 150px;
		overflow: hidden;
	}

	.systemModulePC-content-table-li-pre {
		flex: .5;
		width: 150px;
		overflow: hidden;
	}

	.systemModulePC-content-table-li-oper {
		flex: .8;
	}

	.systemModulePC-add-code {
		padding: 0 20px;
	}

	.systemModulePC-add-code-table-li {
		display: flex;
		height: 40px;
		line-height: 40px;
		text-align: center;
	}

	.systemModulePC-add-code-table-li>div {
		border: 1px solid #CDCDCD;
		border-top: none;
	}

	.systemModulePC-add-code-table-li:first-child>div {
		border-top: 1px solid #CDCDCD;
	}

	.systemModulePC-add-code-table-li>div:first-child {
		border-right: none;
	}

	.systemModulePC-add-code-table-li>div:last-child {
		border: none;
	}

	.systemModulePC-add-code-table-li-name {
		flex: 1;
		background:rgba(240,252,255,1);
	}

	.systemModulePC-add-code-table-li-ipt {
		flex: 1;
	}

	.systemModulePC-add-code-table-li-ipt input {
		height: 100%;
		width: 100%;
		border: none;
		vertical-align: top;
		box-sizing: border-box;
		text-align: center;
		font-size: 14px;
	}

	.systemModulePC-add-code-table-li-ipt input:focus {
		outline: none;
	}

	.systemModulePC-add-code-table-li-text {
		flex: .3;
		color: #FF4D35;
	}

	.systemModulePC-add-code-btn {
		margin-top: 20px;
		text-align: center;
	}

	.systemModulePC-pagesize {
		margin-top: 20px;
		text-align: right;
	}
	/* 按钮管理 */
	.systemModule .el-button--info:hover{
		background-color: #EAC50F;
		border-color: #EAC50F;
	}
</style>
<style>
.system-settings-system-module-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.system-settings-system-module-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.system-settings-system-module-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.system-settings-system-module-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.system-settings-system-module-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
